import Rest from '../Rest'

export default class CalendarService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/calendar'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  events() {
    return this.get('events').then((data) => {
      return data
    })
  }

  scheduleEvent(event) {
    return this.post('event', event).then((data) => {
      return data
    })
  }

  updateEvent(id, data) {
    return this.post(`event/${id}`, data).then((response) => {
      return response
    })
  }

  removeEvent(id) {
    return this.delete(`event/${id}`).then(
      (response) => {
        return response
      }
    )
  }

  /*
   * Os pares `*Event` e `*EventAsTeacher` batem em endpoints diferentes de
   * propósito, e escolher errado não dá erro de compilação — dá 404 em tempo de
   * execução.
   *
   * `students/events/*` confere posse: só o dono da reserva passa. Serve à tela
   * "Minhas Aulas (aluno)", onde quem age é o próprio aluno.
   *
   * `teachers/events/*` confere permissão + escopo do estabelecimento. Serve à
   * tela "Minhas Aulas" do professor, que age sobre a reserva de OUTRA pessoa.
   * A tela do professor chamava as três de aluno e, como professor nunca é dono
   * da reserva do aluno, cancelar/remarcar/confirmar de lá falhava sempre.
   *
   * O cancelamento pelo professor não é só outra rota: é ele que abre a
   * solicitação de cancelamento com estorno quando não há remarcação possível.
   */
  confirmEvent(id, data) {
    return this.post(`students/events/${id}/confirm`, data).then((response) => {
      return response
    })
  }

  cancelEvent(id, data) {
    return this.post(`students/events/${id}/cancel`, data).then((response) => {
      return response
    })
  }

  rescheduleEvent(id, data) {
    return this.post(`students/events/${id}/reschedule`, data).then((response) => {
      return response
    })
  }

  confirmEventAsTeacher(id, data) {
    return this.post(`teachers/events/${id}/confirm`, data).then((response) => {
      return response
    })
  }

  cancelEventAsTeacher(id, data) {
    return this.post(`teachers/events/${id}/cancel`, data).then((response) => {
      return response
    })
  }

  rescheduleEventAsTeacher(id, data) {
    return this.post(`teachers/events/${id}/reschedule`, data).then((response) => {
      return response
    })
  }

  getEventStudents(eventId) {
    return this.get(`teachers/events/${eventId}/students`).then((response) => {
      return response
    })
  }
}
